import { getInstanceID } from "redline-client-sdk"

export default function getInstanceId() {
  return getInstanceID() || ""
}
